module.exports = __webpack_public_path__ + "static/img/voice_room_gift.79da0c69.png";